import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import TransferConsultationHeader from '../components/Service/TransferConsultation/TransferConsultationHeader';
import TransferConsultationInfo from '../components/Service/TransferConsultation/TransferConsultationInfo';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';

export default function TransferConsultation() {
    return (
        <>
            <Header/>
            <TransferConsultationHeader />
            <TransferConsultationInfo />
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}